module.exports = __webpack_public_path__ + "img/C03TechLongswordsmanMaster_ua.b228910c.webp";